import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
  },
  bolder: {
    fontWeight: "bolder",
  },
  legendContainer: {
    marginBottom: theme.spacing(2),
    "& svg": {
      height: ({ isXl }) => (isXl ? 10 : 20),
      width: ({ isXl }) => (isXl ? 10 : 20),
    },
  },
}));

export default useStyles;
